import { render, staticRenderFns } from "./PublicVotingResults.vue?vue&type=template&id=3c2e99e3&scoped=true"
import script from "./PublicVotingResults.vue?vue&type=script&lang=js"
export * from "./PublicVotingResults.vue?vue&type=script&lang=js"
import style0 from "./PublicVotingResults.vue?vue&type=style&index=0&id=3c2e99e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e99e3",
  null
  
)

export default component.exports